export enum SupervisorTransportDocumentTypeEnum {
    ADR = 1,
    DGN = 2
}